// src/pages/Login/Login.js
import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import api from '../../api/api';

const Login = () => {
  const navigate = useNavigate();
  const { loginUser } = useContext(AuthContext);
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState(null);

  const handleForgotPassword = () => {
    navigate("/reset-password");
  };

  const handleSignup = () => {
    navigate("/signup");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Use Axios instance from api.js to post login data
      const res = await api.post('/api/users/login', { email, password });
      const data = res.data;
      
      // If there's an error message in the response, set error state
      if (data.message && data.message !== 'Login successful') {
        setError(data.message || 'Login failed');
      } else {
        // Save tokens and user data via context (ensure AuthContext.loginUser handles these)
        loginUser(data.user, data.accessToken, data.refreshToken);
        navigate('/');
      }
    } catch (err) {
      setError('Login failed. Please try again.');
      console.error(err);
    }
  };

  return (
    <section className="login">
      <style>{`header { display: none; }`}</style>
      <div className="container-fluid">
        <div className="row">
          <div className="col-xs-12 col-sm-6">
            <div className="login-graphic middle center">
              <img src="/images/Logo.svg" alt="Logo" />
            </div>
          </div>
          <div className="col-xs-12 col-sm-6 first-xs last-sm">
            <div className="login-form middle center">
              <form onSubmit={handleSubmit}>
                <h5 className="text-center">Log In</h5>
                {error && <p className="fail">{error}</p>}
                <div className="text-uppercase margin-top-l">Email</div>
                <input 
                  type="email" 
                  name="Email" 
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required 
                />
                <div className="text-uppercase margin-top-l">Password</div>
                <input 
                  type="password" 
                  name="Password" 
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required 
                />
                <button
                  type="button"
                  className="text-link lowercase dimmed full-width margin-top-m text-right"
                  onClick={handleForgotPassword}
                >
                  I don't remember
                </button>
                <div className="form-footer margin-top-l middle">
                  <button
                    type="button"
                    className="text-link"
                    onClick={handleSignup}
                  >
                    or sign up here
                  </button>
                  <button type="submit" data-value="question form">Log in</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Login;
